import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
  icon?: string;
}

export default function SectionTitle({
  title,
  subtitle,
  linkTo,
  linkLabel = '更多',
  icon,
}: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4">
      <div>
        <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
          {icon && (
            <span className="w-5 h-5 flex items-center justify-center text-primary-600">
              <i className={`${icon} text-xl`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="shrink-0 text-sm text-primary-700 hover:text-primary-800 cursor-pointer flex items-center gap-1 whitespace-nowrap"
        >
          {linkLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-base" />
          </span>
        </Link>
      )}
    </div>
  );
}